export default __webpack_public_path__ + "static/media/TimeIcon.595d984c.svg";